import {keyBy, groupBy, empty, createSelector} from 'helpers';
import {RootState} from 'store/root-state.type';

export const goals = (state: RootState) => state.goals?.index ?? empty;

export const byType = createSelector(
  [goals],
  (goals) => groupBy(goals, ({isMajor, isTemplate, parent_id}) => isTemplate ? 'templates' : parent_id ? 'milestones' : isMajor === 0 ? 'examples' : 'goals')
);

export const weeklyObjectives = createSelector(
  [goals],
  (goals) => Object.values(goals)
    .filter(goal => goal.isWeeklyObjective)
    .sort((a, b) => (a.target_date || 0) - (b.target_date || 0))
);

export const goalsList = createSelector(
  [byType],
  ({goals}) => goals || [],
);

export const milestonesById = createSelector(
  [goals],
  (goals) => groupBy(goals, goal => goal.parent_id || goal.id)
);

export const inProgress = createSelector(
  [goalsList],
  (goalsList) => goalsList.filter(goal => goal.status == 'In Progress'),
);

export const byLocalMark = createSelector(
  [inProgress],
  (inProgress) => keyBy(inProgress, 'localMark'),
);

export const byParentId = createSelector(
  [byType],
  ({milestones}) => groupBy(milestones, 'parent_id'),
);

export const byProjectId = createSelector(
  [byType],
  ({goals}) => groupBy(goals, 'typeId'),
);
